import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center text-center">
      <h1 className="text-2xl font-semibold text-edlab-ink">Page not found</h1>
      <p className="mt-2 text-sm text-edlab-muted">
        The page you requested does not exist.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-lg bg-edlab-green px-4 py-2 text-sm font-medium text-white hover:bg-edlab-green-dark"
      >
        Return home
      </Link>
    </div>
  );
}
